import React from "react";
import "./index.scss";
import weprep from "../../img/Rectangle 2184.png";
import OtherArt from "../../components/OtherArt";
import Comment from "../../components/Comment";

const AfterSub = () => {
  return (
    <div id="comment">
      <div id="weprep">
        <div className="container">
          <div className="weprep">
            <p>
              Главная / <span>Статья / Мы подготовили... </span>
            </p>
            <p>11.09.2022</p>
            <div className="weprep--title">
              <h1>
                Мы подготовили подборку самых популярных курсов по направлению
                Java в IBS Training Center.
              </h1>
              <p>
                Когда-то ни один крупный проект не обходился без применения
                функционального и асинхронного программирования. Эти подходы до
                сих пор популярны за счет своих преимуществ: они помогают
                выдерживать большие нагрузки и писать эффективный код, не теряя
                в скорости разработки.{" "}
              </p>
              <img src={weprep} alt="" />
              <p>
                В рамках курса от IBS Training Center вы поймете, как работают
                основные фичи Spring Framework 5, и узнаете:
              </p>
              <li>Какие существуют конфигурации для Spring Framework 5;</li>
              <li>
                Как работать с REST-сервисами и документацией при помощи
                Swagger.
              </li>
              <li>Что такое бины и как с ними работать;</li>
              <li>Что такое Концепция IoC;</li>
              <li>Примеры использования AOP;</li>
              <p style={{padding: "10px 0"}}>
                Ищите способы ускорить проектирование приложений? Используйте
                Spring Framework 5. Этот легковесный каркас с открытыми
                исходными текстами не связан с конкретной моделью
                программирования и поэтому универсален. Его можно использовать
                не только для крупных корпоративных кейсов, но и для небольших
                проектов.
              </p>
              <p style={{padding: "20px 0"}}>
                Интересно? Присоединяйтесь к нашему курсу и узнайте об основных
                модулях этого фреймворка, вариантах их использования и как
                Spring Framework работает совместно с другими технологиями.
              </p>
              <p style={{padding: "20px 0"}}>
                Если вы уже знакомы с Spring Framework 5 и хотите углубить свои
                знания, то этот курс для вас! Вместе с IBS Training Center вы
                изучите темы, необходимые для профессионального применения
                Spring Framework на практике. Вы познакомитесь со Spring REST,
                HATEOAS и CORS, научитесь использовать сериализацию и
                ограничение данных, освоите тонкости применения аннотации
                @Transactional и оптимистических транзакций.
              </p>
              <p style={{padding: "20px 0"}}>
                Также вас ждет много практики, разбор реальных кейсов и другие
                важные темы:
              </p>
              <li>JWT-авторизация;</li>
              <li>Практическое применение реактивного программирования с использованием WebFlux;</li>
              <li>Тестирование Spring-сервисов</li>
              <li>Тестирование Spring-сервисов</li>
            </div>
          </div>
        </div>
        <h1
          style={{
            color: "white",
            padding: "100px 0 10px 70px",
          }}
        >
          Комментарии
        </h1>
        <Comment />
        <h1
          style={{
            color: "white",
            padding: "10px 0 10px 70px",
          }}
        >
          Другие статьи{" "}
        </h1>
        <OtherArt />
      </div>
    </div>
  );
};

export default AfterSub;
